import { t } from '../../../../services/i18nService';
import liveSessionService from '../../../../services/livesession/LiveSessionService';
import preCheckService from '../../../../services/PreCheckService';
import remoteOralExamService from '../../../../services/RemoteOralExamService';
import sessionReader from '../../../../store/readHelpers/SessionReader';

const audioVideoCheckSelector = {
    selectIsFailed(isHardwareAccessRejected, isZoomCheckFailed) {
        return isHardwareAccessRejected || isZoomCheckFailed;
    },

    selectShowZoomTestCallCheck(remoteOralExam, showHardwareAccessCheck) {
        return sessionReader.isRemoteOralCallCheckEnabled()
            && !showHardwareAccessCheck
            && !remoteOralExamService.isZoomTestCallConfirmed(remoteOralExam);
    },

    selectHardwareStatusDescription(isHardwareAccessRejected) {
        return (isHardwareAccessRejected)
            ? t('hardwareAccessCheck.accessRejected')
            : null;
    },

    selectOfferHardwareGrantAccess(livestream) {
        return liveSessionService.isHardwareAccessNotRequested(livestream);
    },

    selectOfferHardwareSwitchDevice(livestream) {
        return liveSessionService.isHardwareAccessGranted(livestream);
    },

    selectTitle(isHardwareAccessRejected, isZoomCheckFailed) {
        if (isHardwareAccessRejected) {
            return t('hardwareAccessCheck.notAllowedAccess');
        }

        return isZoomCheckFailed
            ? t('remoteOralExam.testCall.tryAgainDescription')
            : t('hardwareAccessCheck.title');
    },

    mapStateToProps({ livestream, remoteOralExam }, { arePreviousChecksComplete }) {
        const isHardwareAccessRejected = liveSessionService.isHardwareAccessRejected(livestream);
        const isZoomCheckFailed = remoteOralExamService.isZoomTestCallFailed(remoteOralExam);

        const isCompleted = preCheckService.audioVideoCheckCompleted();
        const offerHardwareGrantAccess = this.selectOfferHardwareGrantAccess(livestream);
        const offerHardwareRetryRequestAccess = isHardwareAccessRejected;
        const offerHardwareSwitchDevice = this.selectOfferHardwareSwitchDevice(livestream);
        const showHardwareAccessCheck = !preCheckService.hardwareCheckCompleted();

        return {
            hardwareStatusDescription: this.selectHardwareStatusDescription(isHardwareAccessRejected),
            isCompleted,
            isCurrent: arePreviousChecksComplete && !isCompleted,
            isFailed: this.selectIsFailed(isHardwareAccessRejected, isZoomCheckFailed),
            isZoomCheckFailed,
            offerHardwareGrantAccess,
            offerHardwareRetryRequestAccess,
            offerHardwareSwitchDevice,
            showHardwareAccessCheck,
            showZoomTestCallCheck: this.selectShowZoomTestCallCheck(remoteOralExam, showHardwareAccessCheck),
            title: this.selectTitle(isHardwareAccessRejected, isZoomCheckFailed),
            zoomTestCallDetail: remoteOralExam.zoomTestCallDetail,
        };
    },
};

export default audioVideoCheckSelector;
